<template>
  <div class="logo-wrapper">
    <img src="@/assets/logo.png" alt="Dailypag" class="logo-image" />
  </div>
</template>

<style scoped>
.logo-wrapper {
  display: flex;
  align-items: center;
  height: 40px; /* Altura fixa e pequena para NÃO aumentar a barra de menu */
  overflow: visible; /* Permite que a logo apareça maior sem empurrar a barra */
}

.logo-image {
  /* O segredo está aqui: */
  height: 65px; /* Aumentamos a imagem... */
  width: auto;
  
  /* ...mas usamos uma margem negativa para ela "ignorar" o limite da barra 
     e não empurrar nada para baixo */
  margin: -5px 0; 
  
  /* O Scale aumenta a percepção de tamanho sem alterar o layout */
  transform: scale(1.4); 
  transform-origin: left center;
  
  object-fit: contain;
}
</style>